import React from "react";
import styles from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage.scss";
import { useAppText } from "src/commun/composants/AppText";

const AppFormErrorMessage = ({ erreur }: { erreur: string }) => {
  const { t } = useAppText();
  return <div className={styles.formErrorMessage}>{t(erreur)}</div>;
};

export const AppFormErrorMessages = ({ erreurs }: { erreurs: string | string[] | undefined }) => {
  if (!erreurs) return <></>;
  else if (typeof erreurs === "string") return <AppFormErrorMessage erreur={erreurs} />;

  return (
    <>
      {Array.isArray(erreurs) &&
        erreurs.map(function(erreur: string, index: number) {
          return <AppFormErrorMessage key={index} erreur={erreur} />;
        })}
    </>
  );
};

export default AppFormErrorMessage;
